<res-base-modal [modalTitle]="'New Organization'" [modalClass]="modalClass" [modalAutomationId]="modalAutomationId"
    [primaryButtonLabel]="'Create Organization'" (primaryButtonActionEmt)="ok()" [isPrimaryBtnEnabled]="okEnabled()"
    (closeButtonActionEmt)="closeModal()" [secondaryButtonLabel]="'Cancel'" [(isBusy)]="isBusy"
    [(isBusyMessage)]="isBusyMessage" [modalHelpIndex]="modalHelpIndex"
    [titleText]="okEnabled()? '' : tooltipPrimaryButton()" [modalDraggable]=false>

    <div class="org-info">
        <res-name-description [automationId]="modalAutomationId" [validateName]="true"
            [validateNameRequest]="validateNameRequest" [changeInputStyleWhenNotValid]="true">
        </res-name-description>
        <div class="group-title">
            <span>Membership</span>
            <button type="button" [attr.data-automation-id]="modalAutomationId + '-add-remove-members-button'"
                class="secondary-button" (click)="editMembers()" [disabled]="membersGrid.isBusy">
                <i class="fa fa-pencil"></i>Add / Remove Members ...
            </button>
        </div>
        <div class="modal-fill members-grid">
            <res-generic-grid gridName="Members" #membersGrid [automationId]="modalAutomationId + '-members'"
                [pagerVisible]="false" [rowHeight]="50" [columnDefs]="membersColumnDefs"
                [gridContext]="membersGridContext" [requestInfo]="membersRequestInfo"
                [responseCallback]="membersResponseCallback">
            </res-generic-grid>
        </div>
    </div>
</res-base-modal>